import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=5db4a200&"
import script from "./Help.vue?vue&type=script&lang=ts&"
export * from "./Help.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports